export const CalcTanDeg = ({ degree }) => {
  const rad = parseFloat(degree) * Math.PI / 180;
  return Math.tan(rad);
};
